import { render, staticRenderFns } from "./ETPraticaPage.vue?vue&type=template&id=0736a3b5&scoped=true&"
import script from "./ETPraticaPage.vue?vue&type=script&lang=js&"
export * from "./ETPraticaPage.vue?vue&type=script&lang=js&"
import style0 from "./ETPraticaPage.vue?vue&type=style&index=0&id=0736a3b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736a3b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0736a3b5')) {
      api.createRecord('0736a3b5', component.options)
    } else {
      api.reload('0736a3b5', component.options)
    }
    module.hot.accept("./ETPraticaPage.vue?vue&type=template&id=0736a3b5&scoped=true&", function () {
      api.rerender('0736a3b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/express-trailers/ETPraticaPage.vue"
export default component.exports